<template>
  <h4 class="card-title font-serif mb-0">
    <slot></slot>
  </h4>
</template>
